import { CompetitorPricingPage } from '../../components/comparisons/CompetitorPricingPage';
import { COMPETITOR_PRICING_MAX_AGE_DAYS, getCompetitorPricing } from '../../data/competitor-pricing';
import { warnStaleEntries } from '../../data/pseo/staleness';
import { isPublishable } from '../../data/pseo/types';

/**
 * Ziflow Pricing (2026): thin page over the shared pricing template. Numbers come from `competitor-pricing.ts`.
 */
const entry = getCompetitorPricing('ziflow');

const WHEN_COMPETITOR_IS_BETTER = [
    "Your team needs 11 to 20 seats on one listed price. Ziflow Standard includes 15 seats and Pro 20; Kreatli above 10 members is Enterprise.",
    "You want a free-forever plan for 2 seats with unlimited reviewers.",
    "You’re happy to commit to annual billing for a flat price. Kreatli is billed monthly only.",
];

export default function ZiflowPricingPage() {
  return (
    <CompetitorPricingPage
      entry={entry}
      documentTitle="Ziflow Pricing (2026): Plans, Limits & Real Cost"
      metaDescription="Ziflow pricing explained: Free, Standard ($199) and Pro ($329) billed annually, 15 or 20 seats included, guest review limits, and real monthly cost."
      h1="Ziflow Pricing (2026)"
      heroText="Ziflow’s flat plans billed annually, how many seats each includes, and what a team of 3, 5, 10 or 15 pays per month."
      publishDate="2026-10-22 00:00"
      readTimeMinutes="7"
      coverSrc="https://a.storyblok.com/f/287637539865613/2250x750/8d83a78aaf/best-video-review-platforms-for-creative-teams-in-2026.png"
      coverAlt="Ziflow pricing breakdown"
      summary="Ziflow’s paid plans are a flat price billed annually: Standard includes 15 seats and Pro includes 20, with unlimited reviewers. That makes the per-seat cost low for bigger teams and high for small ones. Secure Guest Reviewing is Enterprise only."
      whenCompetitorIsBetter={WHEN_COMPETITOR_IS_BETTER}
    />
  );
}

export function getStaticProps() {
  warnStaleEntries('competitor-pricing', [entry], COMPETITOR_PRICING_MAX_AGE_DAYS);
  if (!isPublishable(entry)) {
    return { notFound: true };
  }
  return { props: {} };
}
